<template>
  <div class="loader ease-linear rounded-full border-8 border-t-8 border-gray-200 size-full"></div>
</template>

<style scoped>
.loader {
  border-top-color: #d7a95c;
  /* Change to your desired color */
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
